module.exports = __webpack_public_path__ + "static/img/sec 05.2c5e97c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/sec 05.png
// module id = G+r0
// module chunks = 12